import { ScrcpyInjectKeyCodeControlMessage } from "./inject-keycode.js";
import { ScrcpyInjectTextControlMessage } from "./inject-text.js";
import { ScrcpyInjectTouchControlMessage } from "./inject-touch.js";
import { ScrcpyRotateDeviceControlMessage } from "./rotate-device.js";
import { ScrcpySetScreenPowerModeControlMessage } from "./set-screen-power-mode.js";
import { ScrcpyControlMessageType } from "./type.js";
export class ScrcpyControlMessageSerializer {
    options;
    /** Control message type values for current version of server */
    types;
    writer;
    scrollController;
    constructor(stream, options) {
        this.writer = stream.getWriter();
        this.options = options;
        this.types = options.getControlMessageTypes();
        this.scrollController = options.getScrollController();
    }
    getActualMessageType(type) {
        const value = this.types.indexOf(type);
        if (value === -1) {
            throw new Error("Not supported");
        }
        return value;
    }
    addMessageType(message, type) {
        message.type = this.getActualMessageType(type);
        return message;
    }
    injectKeyCode(message) {
        return this.writer.write(ScrcpyInjectKeyCodeControlMessage.serialize(this.addMessageType(message, ScrcpyControlMessageType.InjectKeyCode)));
    }
    injectText(text) {
        return this.writer.write(ScrcpyInjectTextControlMessage.serialize({
            text,
            type: this.getActualMessageType(ScrcpyControlMessageType.InjectText),
        }));
    }
    /**
     * `pressure` is a float value between 0 and 1.
     */
    injectTouch(message) {
        return this.writer.write(ScrcpyInjectTouchControlMessage.serialize(this.addMessageType(message, ScrcpyControlMessageType.InjectTouch)));
    }
    /**
     * `scrollX` and `scrollY` are float values between 0 and 1.
     */
    injectScroll(message) {
        const data = this.scrollController.serializeScrollMessage(this.addMessageType(message, ScrcpyControlMessageType.InjectScroll));
        if (!data) {
            return;
        }
        return this.writer.write(data);
    }
    async backOrScreenOn(action) {
        const buffer = this.options.serializeBackOrScreenOnControlMessage({
            action,
            type: this.getActualMessageType(ScrcpyControlMessageType.BackOrScreenOn),
        });
        if (buffer) {
            return await this.writer.write(buffer);
        }
    }
    setScreenPowerMode(mode) {
        return this.writer.write(ScrcpySetScreenPowerModeControlMessage.serialize({
            mode,
            type: this.getActualMessageType(ScrcpyControlMessageType.SetScreenPowerMode),
        }));
    }
    rotateDevice() {
        return this.writer.write(ScrcpyRotateDeviceControlMessage.serialize({
            type: this.getActualMessageType(ScrcpyControlMessageType.RotateDevice),
        }));
    }
    close() {
        return this.writer.close();
    }
}
//# sourceMappingURL=serializer.js.map